"use strict";

import * as React from 'react';
export const DrawerGestureContext = /*#__PURE__*/React.createContext(undefined);
//# sourceMappingURL=DrawerGestureContext.js.map